import request from './api/request'
import utils from '@/utils/index'
import pfile from '@/utils/secretkey/pfile'
import sfile from '@/utils/secretkey/sfile'

var ak = utils.genak()
var ed = utils.re(ak, unescape(pfile)) //秘钥

function decrypt(data) {
  if (data?.ak) {
    let plaintext = utils.rd(data.ak, unescape(sfile))
    let obj = utils.secret(data.ed, plaintext, true)
    return JSON.parse(obj)
  } else {
    return data
  }
}

function inParameter(data) {
  if (data) {
    return { sn: ed, jt: utils.secret(data, ak) }
  } else {
    return data
  }
}
// 获取首页发现数据
export function getHomeList(data) {
  return request({
    url: '/cloud/homeRecommend',
    method: 'post',
    data: inParameter(data),
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}

// 订阅
export function checkModirlt(data) {
  return request({
    url: '/jx/modirlt',
    method: 'post',
    data,
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}
//点赞接口
export function checkLike(data) {
  return request({
    url: '/jx/todoLike',
    method: 'post',
    data: inParameter(data),
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}

//收藏接口
export function checkCollec(data) {
  return request({
    url: '/jx/collectPost',
    method: 'post',
    data,
  })
    .then(res => {
      return res
    })
    .catch(err => {})
}
//获取帖子详情
export function getDetailAPI(data) {
  return request({
    url: '/jx/postDetail',
    method: 'post',
    data: inParameter(data),
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}
//获取帖子评论
export function getCommetAPI(data) {
  return request({
    url: '/jx/getPostComment',
    method: 'post',
    data: inParameter(data),
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}
// 获取帖子子评论数据
export function getCommetChildAPI(data) {
  return request({
    url: '/jx/getPostCommentChild',
    method: 'post',
    data: inParameter(data),
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}
// 评论帖子
export function checkCommetAPI(data) {
  return request({
    url: '/jx/postComment',
    method: 'post',
    data: inParameter(data),
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}
// 评论置顶
export function getCommetTopAPI(data) {
  return request({
    url: '/jx/topUpComment',
    method: 'post',
    data: inParameter(data),
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}
// 评论删除
export function delCommetAPI(data) {
  return request({
    url: 'jx/delPostComment',
    method: 'post',
    data: inParameter(data),
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}
// 资源点击上报
export function setReportedAPI(data) {
  return request({
    url: '/buryLog/reportedResources',
    method: 'post',
    data: inParameter(data),
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}
// 老项目埋点接口
export function setReportedTwoAPI(data) {
  return request({
    url: '/buryLog/reported',
    method: 'post',
    data,
  })
    .then(res => {
      return res
    })
    .catch(err => {})
}
// 老项目埋点接口2
export function setReportedThreeAPI(data) {
  return request({
    url: '/cloud/logWayRecord',
    method: 'post',
    data,
  })
    .then(res => {
      return res
    })
    .catch(err => {})
}
// 帖子分享
export function setShare(data) {
  return request({
    url: '/jx/postShare',
    method: 'post',
    data,
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}
// feemoo下载
export function fmDonwList(data) {
  return request({
    url: '/jx/articleDownV2',
    method: 'post',
    data: inParameter(data),
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}
// 本地下载
export function localDownAPI(data) {
  return request({
    url: '/jx/jxdown',
    method: 'post',
    data: inParameter(data),
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}
//获取用户弹窗提示信息接口
export function userMsg(data) {
  return request({
    url: '/cloudFile/userMsg',
    method: 'post',
    data,
  })
    .then(res => {
      return res
    })
    .catch(err => {})
}
//使用橘猫云会员功能接口
export function userMsg2(data) {
  return request({
    url: '/cloudFile/useFunctionality',
    method: 'post',
    data,
  })
    .then(res => {
      return res
    })
    .catch(err => {})
}
//下载 判断操作是否需要安全性校验
export function userMsg3(data) {
  return request({
    url: '/cloud/beforeActionCheck',
    method: 'post',
    data,
  })
    .then(res => {
      return res
    })
    .catch(err => {})
}
//app扫码安全风险验证
export function userMsg4(data) {
  return request({
    url: '/api/getnwcodev2',
    method: 'post',
    data: inParameter(data),
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}
// app扫码状态
export function userMsg5(data) {
  return request({
    url: '/api/checknwcode',
    method: 'post',
    data: inParameter(data),
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}
// 下载
export function userMsg6(data) {
  return request({
    url: '/cv/cvDownload',
    method: 'post',
    data: inParameter(data),
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}

// 获取验证码
export function getSendMsg(data) {
  return request({
    url: '/llz/sendMsg',
    method: 'post',
    data,
  })
    .then(res => {
      return res
    })
    .catch(err => {})
}
// 绑定手机号
export function bindPhoneAPI(data) {
  return request({
    url: '/center/bindPhone',
    method: 'post',
    data,
  })
    .then(res => {
      return res
    })
    .catch(err => {})
}
// 获取区号
export function getPhonePcodeAPI() {
  return request({
    url: '/center/getPhonePcode',
    method: 'post',
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}
// 发送短信
export function sendMsgCheck(data) {
  return request({
    url: '/center/beingphonesendmsgV2',
    method: 'post',
    data,
  })
    .then(res => {
      return res
    })
    .catch(err => {})
}
// 验证
export function msgCheck(data) {
  return request({
    url: '/center/checkBeingPhoneMsg',
    method: 'post',
    data,
  })
    .then(res => {
      return res
    })
    .catch(err => {})
}

// 获取二维码
export function getqrCode(data) {
  return request({
    url: '/api/generateRiskQrcode',
    method: 'post',
    data,
  })
    .then(res => {
      return res
    })
    .catch(err => {})
}
// 判断二维码扫码状态
export function checkQrCode(data) {
  return request({
    url: '/api/queryQrcode',
    method: 'post',
    data,
  })
    .then(res => {
      return res
    })
    .catch(err => {})
}
// 点击查看全文
export function getMoreInfo(data) {
  return request({
    url: '/jx/gethfcon',
    method: 'post',
    data: inParameter(data),
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}
// 获取弹幕数据
export function getDanmuList(data) {
  return request({
    url: '/jx/videodanmu',
    method: 'post',
    data,
  })
    .then(res => {
      return res
    })
    .catch(err => {})
}
// 视频统计接口  4.视频有卡片 5.点击视频里的卡片
export function videolog(data) {
  return request({
    url: '/down/lock_video_play_stat_log',
    method: 'post',
    data,
  })
    .then(res => {
      return res
    })
    .catch(err => {})
}
// 下载重试接口
export function retryDownAPI(data) {
  return request({
    url: '/jx/retryDown',
    method: 'post',
    data: inParameter(data),
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}
// 判断是否有首免
export function getNextPointAPI(data) {
  return request({
    url: '/jx/getNextPoint',
    method: 'post',
    data,
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}
